import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-engg-procure-kpi',
  templateUrl: './engg-procure-kpi.component.html',
  styleUrls: ['./engg-procure-kpi.component.css']
})
export class EnggProcureKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi3: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  EnggProcureKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi2: boolean = false;
  manfMonthFilterKpi2: monthFilter;

  Highcharts = Highcharts;

  totalDataC40: any;
  totalDataKpiChartOptionsC40: Highcharts.Options;
  panelWiseDataC40: any;
  panelWiseKpiChartOptionsC40: Highcharts.Options;

  totalDataC50: any;
  totalDataKpiChartOptionsC50: Highcharts.Options;
  panelWiseDataC50: any;
  panelWiseKpiChartOptionsC50: Highcharts.Options;

  totalDataC60: any;
  totalDataKpiChartOptionsC60: Highcharts.Options;
  panelWiseDataC60: any;
  panelWiseKpiChartOptionsC60: Highcharts.Options;

  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-3', this.isManfMonthFilterSelectedKpi2 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi2) {
      this._dataService.setCookie('s-manfmonth-val-kpi-3', this.manfMonthFilterKpi2.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-3');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi2 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-3');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi2 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi2 == null) {
      this.manfMonthFilterKpi2 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi3 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi2 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi2 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpEnggProcureKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyC40: number = 0;
    let _delayQtyC40: number = 0;
    let _onTimeQtyC40: number = 0;
    let _delayQtyC40ZS1: number = 0;
    let _onTimeQtyC40ZS1: number = 0;
    let _delayQtyC40ZS1DBB: number = 0;
    let _onTimeQtyC40ZS1DBB: number = 0;
    let _delayQtyC40ZS2: number = 0;
    let _onTimeQtyC40ZS2: number = 0;
    let _delayQtyC40ZS9: number = 0;
    let _onTimeQtyC40ZS9: number = 0;
    let _delayQtyC40ZN1: number = 0;
    let _onTimeQtyC40ZN1: number = 0;

    let _totalQtyC50: number = 0;
    let _delayQtyC50: number = 0;
    let _onTimeQtyC50: number = 0;
    let _delayQtyC50ZS1: number = 0;
    let _onTimeQtyC50ZS1: number = 0;
    let _delayQtyC50ZS1DBB: number = 0;
    let _onTimeQtyC50ZS1DBB: number = 0;
    let _delayQtyC50ZS2: number = 0;
    let _onTimeQtyC50ZS2: number = 0;
    let _delayQtyC50ZS9: number = 0;
    let _onTimeQtyC50ZS9: number = 0;
    let _delayQtyC50ZN1: number = 0;
    let _onTimeQtyC50ZN1: number = 0;

    let _totalQtyC60: number = 0;
    let _delayQtyC60: number = 0;
    let _onTimeQtyC60: number = 0;
    let _delayQtyC60ZS1: number = 0;
    let _onTimeQtyC60ZS1: number = 0;
    let _delayQtyC60ZS1DBB: number = 0;
    let _onTimeQtyC60ZS1DBB: number = 0;
    let _delayQtyC60ZS2: number = 0;
    let _onTimeQtyC60ZS2: number = 0;
    let _delayQtyC60ZS9: number = 0;
    let _onTimeQtyC60ZS9: number = 0;
    let _delayQtyC60ZN1: number = 0;
    let _onTimeQtyC60ZN1: number = 0;

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi3.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi3[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for C40 planned and Actual Dates      

            if (_tmpSSO.enggProcureIP.plannedC40Date != null && _tmpSSO.enggProcureIP.actualC40Date != null) {


              // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyC40 += temp;
                }
              }
            });

            let isRevisedC40 = _tmpSSO.enggProcureIP.plannedC40DateisRevised;

              let _c40Planned = _tmpSSO.enggProcureIP.plannedC40Date.getTime();
              let _c40Actual = _tmpSSO.enggProcureIP.actualC40Date.getTime();
              let _c40Diff_time = _c40Planned - _c40Actual;
              let _c40Diff = _c40Diff_time / (1000 * 3600 * 24);

              // C40 Delay
              if (_c40Diff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyC40 += temp;
                    }
                  }
                });

                let _individualDelayQtyC40 = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC40ZS1 += temp;
                          _individualDelayQtyC40 += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC40ZS1DBB += temp;
                          _individualDelayQtyC40 += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC40ZS2 += temp;
                          _individualDelayQtyC40 += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC40ZN1 += temp;
                          _individualDelayQtyC40 += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC40ZS9 += temp;
                          _individualDelayQtyC40 += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedC40 == true? null: _tmpSSO.enggProcureIP.plannedC40Date;
                let _revisedTmp = isRevisedC40 == false? null:_tmpSSO.enggProcureIP.plannedC40Date;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'C40',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyC40, _plannedTmp, _revisedTmp , null, _tmpSSO.enggProcureIP.actualC40Date, _c40Diff, _tmpSSO.enggProcureIP.actualC40Token.addNotes)

                _tmpEnggProcureKpi.push(_tmpSSOobj);
              }
              // C40 on Time
              if (_c40Diff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyC40 += temp;
                    }
                  }
                });

                let _individualOnTimeQtyC40 = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC40ZS1 += temp;
                          _individualOnTimeQtyC40 += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC40ZS1DBB += temp;
                          _individualOnTimeQtyC40 += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC40ZS2 += temp;
                          _individualOnTimeQtyC40 += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC40ZN1 += temp;
                          _individualOnTimeQtyC40 += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC40ZS9 += temp;
                          _individualOnTimeQtyC40 += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedC40 == true? null: _tmpSSO.enggProcureIP.plannedC40Date;
                let _revisedTmp = isRevisedC40 == false? null:_tmpSSO.enggProcureIP.plannedC40Date;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'C40',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyC40, _plannedTmp, _revisedTmp , null, _tmpSSO.enggProcureIP.actualC40Date, _c40Diff, _tmpSSO.enggProcureIP.actualC40Token.addNotes)

                _tmpEnggProcureKpi.push(_tmpSSOobj);
              }


            }



            ////////////////////////// Check for C50 planned and Actual Dates      

            if (_tmpSSO.enggProcureIP.plannedC50Date != null && _tmpSSO.enggProcureIP.actualC50Date != null) {
               // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyC50 += temp;
                }
              }
            });

              let isRevisedC50 = _tmpSSO.enggProcureIP.plannedC50DateIsRevised;

              let _c50Planned = _tmpSSO.enggProcureIP.plannedC50Date.getTime();
              let _c50Actual = _tmpSSO.enggProcureIP.actualC50Date.getTime();
              let _c50Diff_time = _c50Planned - _c50Actual;
              let _c50Diff = _c50Diff_time / (1000 * 3600 * 24);

              // C50 Delay
              if (_c50Diff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyC50 += temp;
                    }
                  }
                });

                let _individualDelayQtyC50 = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC50ZS1 += temp;
                          _individualDelayQtyC50 += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC50ZS1DBB += temp;
                          _individualDelayQtyC50 += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC50ZS2 += temp;
                          _individualDelayQtyC50 += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC50ZN1 += temp;
                          _individualDelayQtyC50 += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC50ZS9 += temp;
                          _individualDelayQtyC50 += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedC50 == true? null: _tmpSSO.enggProcureIP.plannedC50Date;
                let _revisedTmp = isRevisedC50 == false? null:_tmpSSO.enggProcureIP.plannedC50Date;

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'C50',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyC50, _plannedTmp, _revisedTmp, null, _tmpSSO.enggProcureIP.actualC50Date, _c50Diff, _tmpSSO.enggProcureIP.actualC50Token.addNotes)

                _tmpEnggProcureKpi.push(_tmpSSOobj);
              }
              // C50 on Time
              if (_c50Diff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyC50 += temp;
                    }
                  }
                });

                let _individualOnTimeQtyC50 = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC50ZS1 += temp;
                          _individualOnTimeQtyC50 += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC50ZS1DBB += temp;
                          _individualOnTimeQtyC50 += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC50ZS2 += temp;
                          _individualOnTimeQtyC50 += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC50ZN1 += temp;
                          _individualOnTimeQtyC50 += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC50ZS9 += temp;
                          _individualOnTimeQtyC50 += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp = isRevisedC50 == true? null: _tmpSSO.enggProcureIP.plannedC50Date;
                let _revisedTmp = isRevisedC50 == false? null:_tmpSSO.enggProcureIP.plannedC50Date;

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'C50',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyC50, _plannedTmp, _revisedTmp, null, _tmpSSO.enggProcureIP.actualC50Date, _c50Diff, _tmpSSO.enggProcureIP.actualC50Token.addNotes)

                _tmpEnggProcureKpi.push(_tmpSSOobj);
              }


            }

            ////////////////////////// Check for C60 planned and Actual Dates      

            if (_tmpSSO.enggProcureIP.plannedC60Date != null && _tmpSSO.enggProcureIP.actualC60Date != null) {
               // Total Panel Qty  

            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyC60 += temp;
                }
              }
            });

              let isRevisedC60 = _tmpSSO.enggProcureIP.plannedC60DateIsRevised;

              let _c60Planned = _tmpSSO.enggProcureIP.plannedC60Date.getTime();
              let _c60Actual = _tmpSSO.enggProcureIP.actualC60Date.getTime();
              let _c60Diff_time = _c60Planned - _c60Actual;
              let _c60Diff = _c60Diff_time / (1000 * 3600 * 24);

              // c60 Delay
              if (_c60Diff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyC60 += temp;
                    }
                  }
                });

                let _individualDelayQtyC60 = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC60ZS1 += temp;
                          _individualDelayQtyC60 += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC60ZS1DBB += temp;
                          _individualDelayQtyC60 += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC60ZS2 += temp;
                          _individualDelayQtyC60 += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC60ZN1 += temp;
                          _individualDelayQtyC60 += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyC60ZS9 += temp;
                          _individualDelayQtyC60 += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedC60 == true? null: _tmpSSO.enggProcureIP.plannedC60Date;
                let _revisedTmp = isRevisedC60 == false? null:_tmpSSO.enggProcureIP.plannedC60Date;

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'C60',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyC60, _plannedTmp, _revisedTmp, null, _tmpSSO.enggProcureIP.actualC60Date, _c60Diff, _tmpSSO.enggProcureIP.actualC60Token.addNotes)

                _tmpEnggProcureKpi.push(_tmpSSOobj);
              }
              // C60 on Time
              if (_c60Diff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyC60 += temp;
                    }
                  }
                });

                let _individualOnTimeQtyC60 = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC60ZS1 += temp;
                          _individualOnTimeQtyC60 += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC60ZS1DBB += temp;
                          _individualOnTimeQtyC60 += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC60ZS2 += temp;
                          _individualOnTimeQtyC60 += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC60ZN1 += temp;
                          _individualOnTimeQtyC60 += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyC60ZS9 += temp;
                          _individualOnTimeQtyC60 += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp = isRevisedC60 == true? null: _tmpSSO.enggProcureIP.plannedC60Date;
                let _revisedTmp = isRevisedC60 == false? null:_tmpSSO.enggProcureIP.plannedC60Date;

                _tmpSSOobj = new UiFunctionalKPI( _tmpSSO.planningIP.plannedManufacturingMonth, 'C60',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyC60, _plannedTmp, _revisedTmp, null, _tmpSSO.enggProcureIP.actualC60Date, _c60Diff, _tmpSSO.enggProcureIP.actualC60Token.addNotes)

                _tmpEnggProcureKpi.push(_tmpSSOobj);
              }


            }

            

          });

        }


      }

    }

    if (_totalQtyC40 != 0 || _onTimeQtyC40 != 0 || _delayQtyC40 != 0) {
      this.totalDataC40 = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyC40,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyC40,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyC40,
        }]
      }

      ];
    }
    else { this.totalDataC40 = null; }

    this.totalDataKpiChartOptionsC40 = this._kpiCharServ.getTotalDataChartOptions(this.totalDataC40);

    if (_onTimeQtyC40ZN1 != 0 || _onTimeQtyC40ZS9 != 0 || _onTimeQtyC40ZS1 != 0 || _onTimeQtyC40ZS1DBB != 0 || _onTimeQtyC40ZS2 != 0
      || _delayQtyC40ZN1 != 0 || _delayQtyC40ZS9 != 0 || _delayQtyC40ZS1 != 0 || _delayQtyC40ZS1DBB != 0 || _delayQtyC40ZS2 != 0) {

      this.panelWiseDataC40 = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyC40ZN1, _onTimeQtyC40ZS9, _onTimeQtyC40ZS1, _onTimeQtyC40ZS1DBB, _onTimeQtyC40ZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyC40ZN1, _delayQtyC40ZS9, _delayQtyC40ZS1, _delayQtyC40ZS1DBB, _delayQtyC40ZS2],
      }

      ];
    }
    else { this.panelWiseDataC40 = null; }

    this.panelWiseKpiChartOptionsC40 = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataC40);

    ////////////////////

    if (_totalQtyC50 != 0 || _onTimeQtyC50 != 0 || _delayQtyC50 != 0) {
      this.totalDataC50 = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyC50,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyC50,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyC50,
        }]
      }

      ];
    }
    else { this.totalDataC50 = null; }

    this.totalDataKpiChartOptionsC50 = this._kpiCharServ.getTotalDataChartOptions(this.totalDataC50);

    if (_onTimeQtyC50ZN1 != 0 || _onTimeQtyC50ZS9 != 0 || _onTimeQtyC50ZS1 != 0 || _onTimeQtyC50ZS1DBB != 0 || _onTimeQtyC50ZS2 != 0
      || _delayQtyC50ZN1 != 0 || _delayQtyC50ZS9 != 0 || _delayQtyC50ZS1 != 0 || _delayQtyC50ZS1DBB != 0 || _delayQtyC50ZS2 != 0) {

      this.panelWiseDataC50 = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyC50ZN1, _onTimeQtyC50ZS9, _onTimeQtyC50ZS1, _onTimeQtyC50ZS1DBB, _onTimeQtyC50ZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyC50ZN1, _delayQtyC50ZS9, _delayQtyC50ZS1, _delayQtyC50ZS1DBB, _delayQtyC50ZS2],
      }

      ];
    }
    else { this.panelWiseDataC50 = null; }

    this.panelWiseKpiChartOptionsC50 = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataC50);


    ////////////////////

    if (_totalQtyC60 != 0 || _onTimeQtyC60 != 0 || _delayQtyC60 != 0) {
      this.totalDataC60 = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyC60,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyC60,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyC60,
        }]
      }

      ];
    }
    else { this.totalDataC60 = null; }

    this.totalDataKpiChartOptionsC60 = this._kpiCharServ.getTotalDataChartOptions(this.totalDataC60);

    if (_onTimeQtyC60ZN1 != 0 || _onTimeQtyC60ZS9 != 0 || _onTimeQtyC60ZS1 != 0 || _onTimeQtyC60ZS1DBB != 0 || _onTimeQtyC60ZS2 != 0
      || _delayQtyC60ZN1 != 0 || _delayQtyC60ZS9 != 0 || _delayQtyC60ZS1 != 0 || _delayQtyC60ZS1DBB != 0 || _delayQtyC60ZS2 != 0) {

      this.panelWiseDataC60 = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyC60ZN1, _onTimeQtyC60ZS9, _onTimeQtyC60ZS1, _onTimeQtyC60ZS1DBB, _onTimeQtyC60ZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyC60ZN1, _delayQtyC60ZS9, _delayQtyC60ZS1, _delayQtyC60ZS1DBB, _delayQtyC60ZS2],
      }

      ];
    }
    else { this.panelWiseDataC60 = null; }

    this.panelWiseKpiChartOptionsC60 = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataC60);




    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.EnggProcureKpi = _tmpEnggProcureKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi2 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi2) {
      return this.manfMonthFilterKpi2.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi2) {
      return this.manfMonthFilterKpi2.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi2.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi2.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi2.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi2.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi2 == true && this.manfMonthFilterKpi2 != null) {
      if (this.manfMonthFilterKpi2.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}